import * as THREE from 'three';
import {PerspectiveCamera} from "three";

export class Popup3D extends THREE.Object3D {
    private el : HTMLElement;
    private camera: THREE.PerspectiveCamera;
    public shouldTiltX: boolean = true;

    constructor(element : HTMLElement, camera : PerspectiveCamera) {
        super();

        this.el = element;
        this.camera = camera;

        this.el.style.position = 'absolute';
        this.el.style.top = '0';
        this.el.id = 'popup3D';
        // this.el.style.zIndex = '1000';
        this.el.style.left = '0';
        // this.el.style.transform = 'translate(-50%, -50%)';
        // this.el.style.pointerEvents = 'none';
        this.el.style.willChange = 'transform';
        this.el.style.transformOrigin = 'bottom center';
    }

    setVisible(visible: boolean) {
        this.visible = visible;
        this.el.style.display = this.visible ? 'block' : 'none';
    }

    update() {
        if (!this.visible) {
            this.el.style.display = 'none';
            return;
        }

        const worldPos = new THREE.Vector3();
        this.getWorldPosition(worldPos);

// A. Project to Screen Space
        const v = worldPos.clone().project(this.camera);
        const x = (v.x * 0.5 + 0.5) * window.innerWidth;
        const y = (-v.y * 0.5 + 0.5) * window.innerHeight;

// B. Calculate Focal Length (CSS Perspective)
// This is the distance from the "eye" to the screen in pixels
        const fovRad = (this.camera.fov * Math.PI) / 180;
        const perspective = window.innerHeight / (2 * Math.tan(fovRad / 2));

// C. Calculate Distance Scale
// To make the popup behave like it has a fixed size in 3D units:
        const distance = worldPos.distanceTo(this.camera.position);
// 1 CSS pixel will equal 1 Three.js unit at this scale:
        const scale = perspective / distance;

        const cameraDir = new THREE.Vector3();
        this.camera.getWorldDirection(cameraDir);

        const toCamera = new THREE.Vector3().subVectors(this.camera.position, worldPos);

        // 2. Calculate the horizontal distance (XZ plane)
        const horizontalDist = Math.sqrt(toCamera.x ** 2 + toCamera.z ** 2);

        // 3. Calculate the Pitch (The "Tilt" you want)
        // This is the angle between the ground and the camera
        const pitch = Math.atan2(toCamera.y, horizontalDist);
        const tiltX = this.shouldTiltX ? pitch * (180 / Math.PI) : 0;

        // 4. Calculate the Roll (Optional: only if your camera tilts sideways)
        // Most cameras (like OrbitControls) keep roll at 0.
        const cameraRotation = new THREE.Euler().setFromQuaternion(this.camera.quaternion, 'YXZ');
        const rollZ = cameraRotation.z * (180 / Math.PI);

        this.el.style.transform = `
            translate3d(${x}px, ${y}px, 0)
            translate(-50%, -100%) 
            /* 3. Apply the 3D Projection Context */
            perspective(${perspective}px)
    
            /* 4. Match Camera Rotation (Optional: for "Signpost" look) */
            /* We use negative tilt because the popup is 'standing' on the floor */
            rotateX(${-tiltX}deg)
            rotateZ(${rollZ}deg)
    
            /* 5. Scale based on distance */
            scale(${scale * this.scale.x}) /* 0.01 is a multiplier to make '100px' a reasonable size */
`;
    }

    dispose() {
        this.el.remove();
    }
}
